import TextLink from './text-link'
import Typography from './typography'

type Props = {
  name?: string
  address1: string
  address2?: string
  zipCode?: string
  city?: string
  country?: string
  className?: string
}

const AddressLink = ({ name, address1, address2, zipCode, city, country, className }: Props) => {
  // Places without a street (e.g. an airport) can have their town as street line and as city.
  const streetParts = [address1, address2]
    .flatMap((line) => line?.split(',') ?? [])
    .map((part) => part.trim().toLowerCase())
  const isCityInStreet = !!city && streetParts.includes(city.trim().toLowerCase())
  const cityLine = [zipCode, isCityInStreet ? undefined : city].filter(Boolean).join(' ')
  const address = [address1, address2, cityLine, country].filter(Boolean).join(', ')
  const label = [name, address].filter(Boolean).join(', ')

  return (
    <Typography variant="tag" className={className}>
      <TextLink
        href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`}
        name={label}
        options={{ target: '_blank', rel: 'noopener noreferrer' }}
      />
    </Typography>
  )
}

export default AddressLink
